import { getLikedProducts as getLikedProductsApi } from '@musinsa/apis-curator';
import { lazyPipe } from '@musinsa/packages-functional';
import {
  validateServiceRequest,
  validateServiceResponse,
  withServiceErrorCapture,
} from '@musinsa/services-common-service-zod4';

import type {
  GetLikedProductsServiceRequest,
  GetLikedProductsServiceResponse,
} from './get-liked-products.dto';
import {
  GetLikedProductsServiceRequestDtoSchema,
  GetLikedProductsServiceResponseDtoSchema,
} from './get-liked-products.dto';

export const getLikedProductsService = withServiceErrorCapture(
  lazyPipe(
    validateServiceRequest(GetLikedProductsServiceRequestDtoSchema),
    async (request: GetLikedProductsServiceRequest): Promise<GetLikedProductsServiceResponse> => {
      const apiResponse = await getLikedProductsApi(request);

      // 다음 페이지 존재 여부 확인 (link.next 값 기준)
      /**
       * NOTE
       * 29CM 좋아요한 상품 API에 경우 필터링을 반영해서 페이징 처리 안됨
       * 예시: 20개 요청 시 17개만 반환될 수 있음
       * total 값을 서버에서 내려줄 수 없는 상황
       */
      const hasNextPage = apiResponse.link?.next !== null && apiResponse.link?.next !== undefined;
      const nextPage = hasNextPage ? request.page + 1 : undefined;

      const transformedList = apiResponse.data.list.map((product) => ({
        ...product,
        goodsNo: product.goodsNo.toString(),
        brandNo: product.brandNo ?? 0,
        extraDiscountAmount: product.extraDiscountAmount ?? 0,
        finalPrice: product.finalPrice ?? product.price,
        finalDiscount: product.finalDiscount ?? product.salesRate ?? 0,
        isLowestPrice: product.isLowestPrice ?? false,
        isExclusive: product.isExclusive ?? false,
      }));

      const response: GetLikedProductsServiceResponse = {
        total:
          apiResponse.link && 'total' in apiResponse.link
            ? ((apiResponse.link as { total: number | null }).total ?? 0)
            : 0,
        list: transformedList,
        pagination: {
          currentPage: request.page,
          pageSize: request.size,
          hasNextPage,
          nextPage,
        },
      };

      return response;
    },
    validateServiceResponse(GetLikedProductsServiceResponseDtoSchema),
  ),
);
